import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpResponse, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalService } from '@23degrees/shared/services/global';

export const euOnlyInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const globalService: GlobalService = inject(GlobalService);

  if (globalService.isServer()) return next(request);
  if (!globalService.isEU()) return next(request);

  const euUrl = request.url.replace('23degrees.io', '23degrees.eu');
  // console.log('#########################', euUrl, '#########################');
  const apiReq = request.clone({ url: euUrl });

  if (!euUrl.includes('style.json')) return next(apiReq);

  return next(apiReq).pipe(
    map((event: HttpEvent<any>) => {
      try {
        if (event instanceof HttpResponse) {
          let body = JSON.stringify(event.body);
          const searchRegExp = /23degrees\.io/g;
          const replaceWith = '23degrees.eu';
          body = body.replace(searchRegExp, replaceWith);
          body = JSON.parse(body);
          // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>', { body });
          return event.clone({
            body,
          });
        }
      } catch (error) {
        return event;
      }
      return event;
    })
  );
};
